import { Helmet } from "react-helmet";
type Props = {
  title: string | undefined;
};

function HelmetCustom(props: Props) {
  const { title = "" } = props;
  return (
    <Helmet>
      <title>{title}</title>
    </Helmet>
  );
}

export default HelmetCustom;
